const event = 'AuthForm';

const formData = {
    name: 'signup',
    action: null,
    error: null,
    autofill: null,
    changes: 'email,firstName,lastName,password'
};

const userData = {
    authType: 'sign_up',
    signinType: 'email'
};

export const tryJoinArray = input => (
    Array.isArray(input) ? input.sort().join(',') : input
);

const createAccountErrorObject = ({ conversationId, error }) => ({
    event,
    conversationId,
    form: {
        ...formData,
        action: 'error',
        error: tryJoinArray(error)
    },
    userData
});

const createAccountFormStartObject = () => ({
    event,
    form: {
        ...formData,
        action: 'start',
        changes: null
    },
    userData
});

const createAccountFormSubmitObject = ({ changes } = {
    changes: formData.changes
}) => ({
    event,
    form: {
        ...formData,
        action: 'submit',
        changes: tryJoinArray(changes)
    },
    userData
});

const createAccountSuccessObject = ({ conversationId }) => ({
    event,
    conversationId,
    form: {
        ...formData,
        action: 'success'
    },
    userData
});

const createAccountInlineErrorObject = ({ changes, error }) => ({
    event,
    form: {
        ...formData,
        action: 'inline_error',
        changes: tryJoinArray(changes),
        error: tryJoinArray(error)
    },
    userData
});

const createAccountVisitLoginObject = () => ({
    event,
    form: {
        ...formData,
        action: 'click_existing_user_login',
        changes: null
    },
    userData
});

export default {
    createAccountErrorObject,
    createAccountFormStartObject,
    createAccountFormSubmitObject,
    createAccountInlineErrorObject,
    createAccountSuccessObject,
    createAccountVisitLoginObject
};
